import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ModelCategory from './ModelCategory';
import { getModelCategoryManager, getUserProfileWidget } from '../../selectors/index';
import {
    postModelCategoryThunk,
    describeModelCategoryThunk,
    setModelCategoryChangeThunk,
    modelCategoryCleanUpThunk
} from '../../actions/modelCategory';

const mapStateToProps = state => {
    return {
        modelCategoryManager: getModelCategoryManager(state),
        userProfileWidgets: getUserProfileWidget(state),
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            saveModelCategory: (modelCategory, widgetCode) => postModelCategoryThunk(modelCategory, widgetCode),
            describeModelCategory: (modelCategoryId, organisationId, widgetCode) => describeModelCategoryThunk(modelCategoryId, organisationId, widgetCode),
            changeModelCategory: selectedModelCategory => setModelCategoryChangeThunk(selectedModelCategory),
            modelCategoryCleanUp: eventCode => modelCategoryCleanUpThunk(eventCode)
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ModelCategory);
